import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Ești sigur?',
    },
    [OrderMethod.Pickup]: 'Clientul a ridicat deja comanda?',
    [OrderMethod.OnSite]: 'Clientul a ridicat deja comanda?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Comanda a fost deja livrată?',
      [DeliveryProvider.UberDrive]: 'Șoferul a ridicat deja comanda?',
      [DeliveryProvider.FirstDelivery]: 'Șoferul a ridicat deja comanda?',
      [DeliveryProvider.WoltDrive]: 'Șoferul a ridicat deja comanda?',
    },
  },
  buttons: {
    cancel: 'Nu, Anulează',
    confirm: 'Da',
  },
};
